(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vat-toggle"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__vatToggleReady) return;
    var STORAGE_KEY = 'vat-display-mode';
    var buttons = document.querySelectorAll('.vat-toggle-button');
    if (!buttons.length) return;
    window.__vatToggleReady = true;

    var getMode = function () {
      return window.localStorage.getItem(STORAGE_KEY) === 'excl' ? 'excl' : 'incl';
    };

    var apply = function () {
      var isExcl = getMode() === 'excl';
      var first = buttons[0];
      var labels = {
        toggleIncl: first.getAttribute('data-label-incl') || 'Incl. BTW',
        toggleExcl: first.getAttribute('data-label-excl') || 'Excl. BTW',
        priceIncl: first.getAttribute('data-price-label-incl') || 'incl. BTW',
        priceExcl: first.getAttribute('data-price-label-excl') || 'excl. BTW'
      };
      document.documentElement.dataset.vatMode = isExcl ? 'excl' : 'incl';
      buttons.forEach(function (button) {
        button.classList.toggle('vat-toggle--excl', isExcl);
        button.classList.toggle('vat-toggle--incl', !isExcl);
        button.setAttribute('aria-pressed', String(!isExcl));
        var text = button.querySelector('.vat-toggle-text');
        if (text) text.textContent = isExcl ? labels.toggleExcl : labels.toggleIncl;
      });
      var priceOnRequestLabel = document.documentElement.dataset.priceOnRequest || 'Prijs op aanvraag';
      document.querySelectorAll('.js-vat-price').forEach(function (el) {
        var onRequest = el.dataset.priceOnRequest === 'true';
        el.classList.toggle('is-price-on-request', onRequest);
        var main = isExcl ? el.dataset.priceExclFormatted : el.dataset.priceInclFormatted;
        var secondary = isExcl ? el.dataset.priceInclFormatted : el.dataset.priceExclFormatted;
        var compare = isExcl ? el.dataset.compareExclFormatted : el.dataset.compareInclFormatted;
        var mainEl = el.querySelector('[data-vat-main]');
        var mainLabelEl = el.querySelector('[data-vat-main-label]');
        var secondaryAmountEl = el.querySelector('[data-vat-secondary-amount]');
        var secondaryLabelEl = el.querySelector('[data-vat-secondary-label]');
        var compareEl = el.querySelector('[data-vat-compare]');
        if (onRequest) {
          if (mainEl) mainEl.textContent = priceOnRequestLabel;
          if (mainLabelEl) mainLabelEl.textContent = '';
          if (secondaryAmountEl) secondaryAmountEl.textContent = '';
          if (secondaryLabelEl) secondaryLabelEl.textContent = '';
          if (compareEl) compareEl.textContent = '';
          return;
        }
        if (mainEl && main) mainEl.textContent = main;
        if (mainLabelEl) mainLabelEl.textContent = isExcl ? labels.priceExcl : labels.priceIncl;
        if (secondaryAmountEl && secondary) secondaryAmountEl.textContent = secondary;
        if (secondaryLabelEl) secondaryLabelEl.textContent = isExcl ? labels.priceIncl : labels.priceExcl;
        if (compareEl && compare) compareEl.textContent = compare;
      });
    };

    window.applyVatDisplay = apply;
    if (!window.localStorage.getItem(STORAGE_KEY)) {
      window.localStorage.setItem(STORAGE_KEY, 'incl');
    }
    apply();
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        window.localStorage.setItem(STORAGE_KEY, getMode() === 'excl' ? 'incl' : 'excl');
        apply();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
